import type { FullVariant } from '../../../services/shop.business'
import type { CooperativeProduct } from '../../../services/product'
import { getConfig } from '@b2ag/micro-front-tools'
import { type ComputedRef, computed } from 'vue'

export function filterVariantsFromProfile(
  variants: ComputedRef<FullVariant<CooperativeProduct['variants'][number]>[]>,
): ComputedRef<FullVariant<CooperativeProduct['variants'][number]>[]> {
  const restriction = getConfig('PRODUCTS_TO_DISPLAY_RESTRICTION')
  if (!restriction) return variants
  return computed(() =>
    variants.value.filter(
      (variant) => !variant.restrictedToProfiles || variant.restrictedToProfiles?.includes(restriction),
    ),
  )
}
